module.exports = __webpack_public_path__ + "static/media/givesounds-1-fix.b42a217f.jpg";